import { jsx as _jsx } from "react/jsx-runtime";
import { focusPosition, frameSource } from '../../../types';
import Img from './img';
// Every photo in a fixed frame goes through here: the smallest of its copies that fills the frame,
// its zoomed copies when its crop zooms in, cropped around its focal point, loaded as it nears the
// screen. A lightbox, which shows the whole photo, reads `photo.url` instead.
const PhotoFrame = (props) => (_jsx(Img, Object.assign({}, frameSource(props.photo), { sizes: props.sizes, alt: props.alt, title: props.title, className: props.className, style: Object.assign({ objectFit: 'cover', objectPosition: focusPosition(props.photo) }, props.style), onClick: props.onClick, loading: props.loading })));
export default PhotoFrame;
